import React from "react";
import ConfirmationModal from "../ConfirmationModal";
import { i18n } from "../../translate/i18n";

const CloseAllTicketsModal = ({ open, onClose, onConfirm }) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={i18n.t("tickets.inbox.closedAllTickets") || "Fechar todos os tickets?"}
    >
      {i18n.t("tickets.inbox.closedAllTicketsDescription") ||
        "Tem certeza que deseja fechar todos os tickets visíveis com os filtros aplicados? Tickets fora do filtro não serão fechados."}
    </ConfirmationModal>
  );
};

export default CloseAllTicketsModal;

